import { ThemeProvider } from '@mui/material/styles'
import { RefineThemes } from '@refinedev/mui'
import React, { PropsWithChildren, useState } from 'react'
import { ColorModeContext } from './context'

export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [mode] = useState('light') // Keep it static, no switching

  return (
    <ColorModeContext.Provider value={{ mode }}>
      <ThemeProvider theme={RefineThemes.Blue}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  )
}
